import React from 'react';
import { bubbleStyle, bubbleHoverStyle } from './coryStyles';

export const CoryBubble = ({ hovered, setHovered, onOpen, proactiveHint }) => (
  <button
    data-testid="cory-chat-bubble"
    onClick={onOpen}
    onMouseEnter={() => setHovered(true)}
    onMouseLeave={() => setHovered(false)}
    className="fixed bottom-6 right-6 z-[60] w-[60px] h-[60px] rounded-full flex items-center justify-center transition-all duration-300 ease-out group"
    style={
      hovered
        ? { ...bubbleStyle, ...bubbleHoverStyle, transform: 'scale(1.08) translateY(-2px)' }
        : bubbleStyle
    }
    aria-label="Open Cory AI Assistant"
  >
    <span className="absolute inset-0 rounded-full border border-white/20 group-hover:border-white/40 transition-colors duration-500" />
    <span className="absolute inset-[6px] rounded-full border border-white/[0.12]" />
    <span
      className="relative text-white font-bold text-xl tracking-tight select-none"
      style={{ textShadow: '0 0 12px rgba(0,122,255,0.6)' }}
    >
      C
    </span>
    <span className="absolute -top-0.5 -right-0.5 w-3.5 h-3.5 rounded-full bg-emerald-400 border-[2.5px] border-white shadow-sm shadow-emerald-400/40" />
    {proactiveHint && (
      <span
        data-testid="cory-proactive-hint"
        className="absolute -top-10 right-0 whitespace-nowrap bg-white/90 backdrop-blur-md text-[#0066CC] text-xs font-medium px-3 py-1.5 rounded-lg shadow-lg border border-[#0066CC]/10 animate-bounce pointer-events-none"
      >
        {proactiveHint}
      </span>
    )}
  </button>
);
